import { IAppState } from '@core/store/types';

export const selectCurrentDeal = (state: IAppState) => state.deal.data;
export const selectLastCategory = (state: IAppState) => state.deal.lastCategory;
